import { render } from "./FormManagement.vue?vue&type=template&id=2d46a07b&scoped=true"
import script from "./FormManagement.js?vue&type=script&lang=js"
export * from "./FormManagement.js?vue&type=script&lang=js"

import "./FormManagement.vue?vue&type=style&index=0&id=2d46a07b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d46a07b"]])

export default __exports__